export function isDescendant(element: HTMLElement | null, ancestorId: string) {
  const ancestor = document.getElementById(ancestorId);
  while (element) {
    if (element === ancestor) {
      return true;
    }
    element = element.parentElement;
  }
  return false;
}

export function isDescendantByClass(element: HTMLElement | null, className: string) {
  while (element) {
    if (element.classList.contains(className)) {
      return true;
    }
    element = element.parentElement;
  }
  return false;
}

export function hasClass(element: HTMLElement | null, className: string) {
  if (element && element.classList.contains(className)) {
    return true;
  } else {
  }
}

export function getRelativeCoordinates(event: {clientX: number; clientY: number;}, scrollElement: HTMLElement) {
  // 获取事件中的屏幕坐标
  const clientX = event.clientX;
  const clientY = event.clientY;

  // 获取滚动元素的滚动偏移量
  const scrollLeft = scrollElement.scrollLeft;
  const scrollTop = scrollElement.scrollTop;

  // 获取滚动元素在视口中的位置
  const rect = scrollElement.getBoundingClientRect();

  // 计算相对于滚动元素的坐标
  const x = clientX - rect.left + scrollLeft;
  const y = clientY - rect.top + scrollTop;

  return { x: x, y: y };
}

export function getTextPosition(element: any) {
  // 获取父元素的文本内容
  const parentText = element.parentElement.textContent;

  // 初始化起始位置和结束位置
  let startPosition = 0;
  let endPosition = 0;

  // 遍历父元素的子节点，查找目标节点之前的文本节点
  for (const node of element.parentElement.childNodes) {
    if (node === element) {
      // 找到目标节点后，记录结束位置
      endPosition = startPosition + (element.textContent || '').length;
      break;
    } else if (node.nodeType === Node.TEXT_NODE) {
      // 如果是文本节点，则更新起始位置
      startPosition += node.textContent.length;
    }
  }

  return { startPosition, endPosition };
}


export const getTextLengthUpToNode = (node: HTMLElement, targetNode: HTMLElement) => {
  let dataLength = 0;
  let realLength = 0;
  const traverseNodes = (currentNode:any, needAdd: boolean) => {
    if (currentNode === targetNode) return true;
    if (currentNode.nodeType === Node.TEXT_NODE) {
      if (needAdd) {
        dataLength += currentNode.nodeValue.length;
      }
      realLength +=currentNode.nodeValue.length;
    } else if (currentNode.nodeType === Node.ELEMENT_NODE) {
      if (currentNode !== node) {
        if (currentNode.hasAttribute('data-key')) {
          // needAdd = false;
          return false;
        } else if (currentNode.hasAttribute('data-disable')) {
          return false;
        }
      }

      const sourceGap = Number(currentNode.getAttribute('data-source-gap'));
      if (sourceGap > 0) {
        if (needAdd) {
          dataLength += sourceGap;
        }
        realLength += sourceGap;
      }

      for (const child of currentNode.childNodes) {
        if (traverseNodes(child, needAdd)) return true;
      }
    }
    return false;
  };
  traverseNodes(node, true);
  return {dataLength, realLength};
};

export function getRangeElements(range: any) {
  const startNode = range.startContainer;
  const endNode = range.endContainer;

  // 获取选择范围内的公共祖先节点
  const commonAncestor = range.commonAncestorContainer;
  const highlightElements: any = [];


  // 遍历选择范围内的节点
  function traverseRange(node: any) {

    if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('highLight') && range.intersectsNode(node)) {
      highlightElements.push(node);
    }


    if (node.childNodes && node.childNodes.length > 0) {
      for (let i = 0; i < node.childNodes.length; i++) {
        traverseRange(node.childNodes[i]);
      }
    }
  }

  if (startNode === endNode ) {
    if (startNode.parentElement.classList.contains('highLight') && range.intersectsNode(startNode.parentElement)) {
      highlightElements.push(startNode.parentElement);
    } else if (startNode.classList.contains('highLight') && range.intersectsNode(startNode) ) {
      highlightElements.push(startNode);
    }
    
  } else {
    traverseRange(commonAncestor);
  }

  

  return highlightElements;
  
}

export function findTextNodeAndRelativePosition(container: any, targetPosition: any) {
  let currentPosition = 0;

  function findNodeAndOffset(node: any): any {
    if (node.nodeType === Node.TEXT_NODE) {
      const textLength = node.textContent.length;

      if (currentPosition + textLength >= targetPosition) {
        const relativePosition = targetPosition - currentPosition;
        return { node, relativePosition };
      } else {
        currentPosition += textLength;
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      for (const child of node.childNodes) {
        const result = findNodeAndOffset(child);
        if (result) return result;
      }
    }

    return null;
  }

  return findNodeAndOffset(container);
}

export function focusNumber(number: number, min: number) {
  let isTop = number === min;
  const isListen = window.location.href.indexOf('mocklistening');

  setTimeout(() => {
    let el: any = document.getElementById(`question${number}`);
    let scrollContatiner: any; 
    if (el) {
      // if (el.hasClass('choiceQuestion')) {
        
      // }
      if (!isTop) {
        isTop = isListen && el.classList.contains('choiceQuestion') && (number - min) <= 1;
      }
      
      scrollContatiner = el.closest('[data-scroll]');
      console.log('isTop', isTop);
      if (isTop && scrollContatiner) {
        scrollContatiner.scrollTo({top: 0, behavior: 'smooth'});
      } else {
        el.scrollIntoView({
          behavior: 'smooth'
        });
      }

      if (el.tagName === 'INPUT') {
        el.focus();
      }      
    } else {
      el = document.getElementsByClassName(`question${number}`)[0];
      if (el) {
        scrollContatiner = el.closest('[data-scroll]');
        if (!isTop) {
          isTop = isListen && el.classList.contains('choiceQuestion') && (number - min) <= 1;
        }
        
        if (isTop && scrollContatiner) {
          scrollContatiner.scrollTo({top: 0, behavior: 'smooth'});
        } else {
          el.scrollIntoView({
            behavior: 'smooth'
          });
        }
        if (el.tagName === 'INPUT') {
          el.focus();
        }  
      } else {
        console.error(`没有id为question${number}这个元素`);
      }
    } 
  }, 20);
}
